import type { CSSProperties, ReactNode } from 'react';
import './NavBarButton.css';

export type NavBarButtonProps = {
  active?: boolean;
  onClick?: () => void;
  className?: string;
  style?: CSSProperties;
  'aria-label'?: string;
  children?: ReactNode;
};

/**
 * Nav tab background surface + bevels.
 * Width comes from flex share of `.nav-bar` (not a fixed Figma slot).
 */
export function NavBarButton({
  active = false,
  onClick,
  className,
  style,
  'aria-label': ariaLabel,
  children,
}: NavBarButtonProps) {
  const classes = [
    'nav-bar-button',
    active ? 'nav-bar-button--active' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      style={style}
      aria-label={ariaLabel}
      aria-pressed={active}
      onClick={onClick}
    >
      <span className="nav-bar-button__surface" aria-hidden />
      {children}
    </button>
  );
}
